import Scene, { ISceneParams } from './Scene';
import Game from '../Game';
import LuckyTurnipsSystem from '../System/LuckyTurnips/LuckyTurnipsSystem';
import TimerSystem from '../System/Timer/TimerSystem';
import AnimationSystem from '../System/Animation/AnimationSystem';
import RenderSystem from '../System/Render/RenderSystem';
import AudioSystem from "System/Audio/AudioSystem";

export default class LuckyTurnipsScene extends Scene {
    public init(): void {
        this.addSystem(new TimerSystem(Game.store));
        this.addSystem(new LuckyTurnipsSystem(Game.store));
        this.addSystem(new AnimationSystem(Game.store));
        this.addSystem(new RenderSystem(Game.store));
        this.addSystem(new AudioSystem(Game.store));

        this.systems.forEach(system => system.init());
    }
}
